import React from "react";
import { PAGE_COMPANY, PAGE_LOATION } from "../../config";
import "./footer.scss";
class Footer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  componentDidMount() {
    console.log(localStorage.getItem('messageNum'));
    console.log(localStorage.getItem('messageNum').split(''));
  }
  render() {
    return (
      <>
        <div className="nav-footer">
          <div className="nav-footer_all" style={{ textAlign: "center" }}>
            <div className="nav-footer_all_con nav-footer_all_con_one">
              <div className="title" style={{ textAlign: "left" }}>
                友情链接：
              </div>
              <div className="gutter-row left">
                <div className="aBox">
                  <div>
                    <a
                      style={{ color: "#fff" }}
                      target="_blank"
                      href="https://zwdt.sh.gov.cn/govPortals/index.do"
                    >
                      上海一网通办
                    </a>
                  </div>
                  <div className="line" />
                  <div>
                    <a
                      style={{ color: "#fff" }}
                      target="_blank"
                      href="https://www.shgjj.com/"
                    >
                      上海市住房公积金网
                    </a>
                  </div>
                </div>

                {/* <div className="companyBox">
                  <div>
                    指导单位：中国（上海）自由贸易试验区临港新片区管理委员会
                  </div>
                  <div>
                    运营单位：上海临港新片区住房建设发展（集团）有限公司
                  </div>
                </div> */}
              </div>
            </div>
            <div className="nav-footer_all_con">
              <div className="title">联系我们</div>
              <div className="gutter-row flex-center">
                <div style={{ margin: "auto" }}>
                  <div className="flex1">
                    <img
                      src={require("../../assets/images/phone.png").default}
                    ></img>
                    <div style={{ marginLeft: "10px", textAlign: "left" }}>
                      联系电话：021-56671727 / 021-56100661
                    </div>
                  </div>
                  <div className="flex1">
                    <img
                      src={require("../../assets/images/location.png").default}
                      width={15}
                      height={15}
                    ></img>
                    <div style={{ marginLeft: "10px", textAlign: "left" }}>
                      受理窗口：宝山区宝杨路1369号自然资源确权登记事务中心1楼32#、33#保租房窗口
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="nav-footer_all_con">
              <div className="title">关注我们</div>
              <div className="gutter-row" style={{ border: "none" }}>
                <div className="guanzhu flex " style={{ with: "100%" }}>
                  <div style={{ width: "50%", textAlign: "center" }}>
                    关注微信公众号
                    <div className="gongzonghao"></div>
                  </div>
                  {/* <div style={{ width: "50%", textAlign: "center" }}>
                    关注微信小程序
                    <div className="xiaochengxu"></div>
                  </div> */}
                  <div style={{ width: "50%", display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                    <span style={{ fontSize: '20px', marginBottom: '20px' }}>浏览网站人数统计</span>
                    {((localStorage.getItem('messageNum') || localStorage.getItem('messageNum') == 0) && localStorage.getItem('messageNum').split('')[0] != 0) ? <div style={{ display: 'flex', justifyContent: 'center' }}>
                      {
                        localStorage.getItem('messageNum').split('').map((item, index) => {
                          return (
                            <p style={{ width: '30px', height: '30px', backgroundColor: '#0061AE', lineHeight: '30px', fontSize: '20px', borderRadius: '5px', margin: '5px' }}>{item}</p>
                          );
                        })
                      }
                    </div> : 0}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div >
        <div className="bottomBox">
          {PAGE_COMPANY}@版权所有
          <a
            href="http://beian.miit.gov.cn/"
            target="_blank"
            style={{ color: "#fff" }}
          >
            &nbsp; 沪ICP备16038301号-1
          </a>
          &nbsp; &nbsp; &nbsp;
          <a
            href="https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011302007421"
            target="_blank"
            style={{ color: "#fff" }}
          >
            <span className="beian"></span> 沪公网安备 31011302007421号
          </a>
        </div>
      </>
      // <div className="nav-footer">
      //     <div className="col-lg-2"></div>
      //     <div className="col-lg-8">
      //         <div>{PAGE_COMPANY} 版权所有 沪ICP备16038301号-1</div>
      //         <div>Copyright ©2021 ShangHai BaoShan Public Rental Housing Operations Co.,Ltd. All Rights Reserved </div>
      //         <div>公司地址: {PAGE_LOATION}</div></div>
      //     <div className="col-lg-2"></div>

      // </div>
    );
  }
}

export default Footer;
